"use client"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useQualityAgentsQuery } from "@/hooks/queries/conversation-quality"

const ALL_AGENTS = "all"

interface QualityAgentSelectProps {
  agentId: string | null;
  onChange: (agentId: string | null) => void;
  className?: string;
}

export function QualityAgentSelect({ agentId, onChange, className }: QualityAgentSelectProps) {
  const { data: agents, isLoading } = useQualityAgentsQuery()

  return (
    <Select
      value={agentId ?? ALL_AGENTS}
      onValueChange={(value) => onChange(value === ALL_AGENTS ? null : value)}
      disabled={isLoading}
    >
      <SelectTrigger className={className} aria-label="Messaging agent">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_AGENTS}>All agents</SelectItem>
        {(agents ?? []).map((agent) => (
          <SelectItem key={agent.id} value={agent.id}>
            {agent.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
